export default function getResource(label) {
    const resources = {
        noProducts: 'Sorry, no products match the applied filters.'
    };

    return resources[label];
}
